import moment from 'moment'

function checkVueLocale (vueContext) {
	if (vueContext && vueContext.$moment.locale() !== vueContext.$i18n.locale) {
		//console.log('checkVueLocale warning')
		vueContext.$moment.locale(vueContext.$i18n.locale)
	}
}

export default {
	// Filter functions
	capitalize (value) {
		if (!value) return ''
		value = value.toString()
		return value.charAt(0).toUpperCase() + value.slice(1)
	},
	toCurrency (value) {
		if (typeof value !== "number") {
				return value
		}
		var formatter = new Intl.NumberFormat(navigator.language, {
				style: 'currency',
				currency: 'EUR',
				minimumFractionDigits: 2
		})
		return formatter.format(value)
	},
	formatDate (date, Vue) {
		checkVueLocale(Vue)
		return Vue ? Vue.$moment(date).format('L') : 'missing Vue context'
	},
	formatTime (date, Vue) {
		checkVueLocale(Vue)
		return Vue ? Vue.$moment(date).format('LT') : 'missing Vue context'
	},
	formatDateTime (date, Vue) {
		checkVueLocale(Vue)
		return `${moment(date).format('L')} ${moment(date).format('LT')}`
	},
	formatHour (hour) {
		return moment(hour, 'HH:mm:ss').format('HH:mm')
	},
	timeAgo (date, Vue) {
		checkVueLocale(Vue)
		return Vue ? Vue.$moment(date).fromNow() : 'missing Vue context'
	},
	// Install vue module
	install (Vue) {
		Vue.filter('capitalize', this.capitalize)
		Vue.filter('toCurrency', this.toCurrency)
		Vue.filter('formatDate', this.formatDate)
		Vue.filter('formatTime', this.formatTime)
		Vue.filter('formatDateTime', this.formatDateTime)
		Vue.filter('formatHour', this.formatHour)
		Vue.filter('timeAgo', this.timeAgo)
	}
}



// WEBPACK FOOTER //
// ./src/utils/filters.js